import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/style/market.reg.module.scss';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';//메뉴
import TitleBar from 'src/webapp/views/component/title/TitleBar';//상단타이틀
import InputField from './MarketReg.DataField';//입력필드

export default function MarketUpdate() {
    /* =============== 하위컴포넌트 내 함수호출 =============== */
    const childRef = useRef();//
    /* =============== 하위컴포넌트 내 함수호출 =============== */
    /* =============== 등록버튼활성화여부 =============== */
    const [ isDisabled, setDisabled ] = useState(true)
    /* =============== 등록버튼활성화여부 =============== */

    return (
        <Section className={["section sectionContainer", styles.marketSection].join(' ')}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <TitleBar title={`내 물건 팔기`} />
                    <Element tag={`div`} className={styles.titleBar}>
                        <Element tag={`div`}>
                            <Link to={-1}><FontAwesomeIcon icon="fa-light fa-xmark" /></Link>
                            <Element tag={`h1`}>내 물건 팔기</Element>
                            <Element tag={`button`}></Element>
                        </Element>
                    </Element>
                </FixedPanel>
                <FlickPanel>
                    <InputField data={null} ref={childRef} isDisabled={isDisabled} setDisabled={setDisabled} type={2} />
                </FlickPanel>
                <FixedPanel>
                    <Element tag={`div`} className={styles.btnArea}>
                        <Link to={-1}><FontAwesomeIcon icon="fa-light fa-chevron-left" /><Element tag={`span`}>이전으로</Element></Link>
                        <button disabled={isDisabled} onClick={() => childRef.current.marketRegAndUpdateAPI(1)}><FontAwesomeIcon icon="fa-light fa-floppy-disk" /><Element tag={`span`}>수정하기</Element></button>
                    </Element>
                </FixedPanel>
            </Element>
        </Section>
    );
}